import React, { createContext, useContext, useState, useCallback } from "react";

import useLocalStorage from "../../hooks/useLocalStorage";
import useGeoLocation from "../../hooks/useGeoLocation";

const UserInfoContext = createContext();

export function UserInfoProvider({ children }) {
	const [userLocation, setUserLocation] = useLocalStorage(
		'user_location',
		'',
	);
	const [activeMunicipality, setActiveMunicipality] = useLocalStorage(
		"municipality",
		''
	);

	const askForUserLocation = async () => {
		const location = await useGeoLocation({enableHighAccuracy: true});
		console.log(location)
		if (location.loaded) {
			setUserLocation(location);
		}
	}




	return (
		<UserInfoContext.Provider
		value={{
			userLocation,
			askForUserLocation,
			activeMunicipality,
		}}>
			{children}
		</UserInfoContext.Provider>
	)
}

export default function useUserInfoContext() {
	const context = useContext(UserInfoContext);

	if (context === undefined) {
		throw new Error(
			"useUserInfoContext must be used within a UserInfoProvider",
		);
	}

	return context;
}
